<!--
 * @Author: your name
 * @Date: 2021-04-14 11:14:14
 * @LastEditTime: 2021-04-26 10:10:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/business/order/index.vue
-->
<template>
  <div class="orderList">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input @keyup.enter.native="onSubmit" style="width: 230px" v-model="formInline.accountName" clearable placeholder="账号名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input @keyup.enter.native="onSubmit" style="width: 230px" v-model="formInline.orderName" clearable placeholder="订单名称/编号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input @keyup.enter.native="onSubmit" style="width: 230px" v-model="formInline.createUserName" clearable placeholder="下单人"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select style="width: 230px" v-model="formInline.orderStatus" clearable placeholder="投放状态">
          <el-option v-for="item in ztList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">搜 索</el-button>
      </el-form-item>
    </el-form>
    <div v-loading="loading">
      <el-table size="small" :data="tableData" style="width: 100%">
        <el-table-column align="center" prop="orderName" width="180" label="账号名称">
          <template slot-scope="scope">
            <div class="accontBox">
              <div style="width:40px;height:40px;">
                <img v-if="scope.row.avatar" style="border-radius: 40px;width:100%;height:100%;" :src="scope.row.avatar" alt="">
                 <img v-else style="border-radius: 40px;width:100%;height:100%;" src="/img/media/weibo_default.png">
              </div>
              <div style="margin-left:10px;text-align:left;">
                <div class="info-wrap">
                  <el-tooltip :content="scope.row.mediaName?scope.row.mediaName:'--'" placement="bottom" effect="light">
                    <div class="nickname"><span>{{ scope.row.mediaName?scope.row.mediaName:'--' }}</span></div>
                  </el-tooltip>
                </div>
                {{ checkNull(scope.row.fansNum) ? '--' : scope.row.fansNum }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="mediaType" width="60" label="平台">
          <template slot-scope="scope">
            <div style="width:40px;height:40px;margin: 0 auto;">
              <!-- 平台logo -->
              <img v-if="scope.row.mediaType == 2" style="width:100%;height:100%;" src="@/assets/img/wb.png" alt="">
              <img v-if="scope.row.mediaType == 3" style="width:100%;height:100%;" src="@/assets/img/xhs.png" alt="">
              <img v-if="scope.row.mediaType == 5" style="width:100%;height:100%;" src="@/assets/img/bz.png" alt="">
              <img v-if="scope.row.mediaType == 6" style="width:100%;height:100%;" src="@/assets/img/ks.png" alt="">
              <div v-if="scope.row.mediaType == 1" class="typeImgWx"></div>
              <div v-if="scope.row.mediaType == 7" class="typeImgTb"></div>
              <div v-if="scope.row.mediaType == 4" class="typeImgDy"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="address" width="160" label="订单信息">
          <template slot-scope="scope">
            <div>{{scope.row.orderName}}</div>
            <div>{{scope.row.orderCode}}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="publishType" label="发布形式">
          <template slot-scope="scope">
            <div>{{scope.row.publishType?scope.row.publishType:'--'}}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="putPrice" label="投放价格">
          <template slot-scope="scope">
            <div>{{scope.row.putPrice?scope.row.putPrice:'--'}}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="publishTime" width="180" label="发布时间">
          <template slot-scope="scope">
            <div>{{scope.row.publishTime?scope.row.publishTime:'--'}}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="createUserName" width="180" label="下单信息">
          <template slot-scope="scope">
            <div>{{scope.row.createUserName?scope.row.createUserName:'--'}}</div>
             <div>{{scope.row.createTime?scope.row.createTime:'--'}}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="orderAccountStatus" label="投放状态">
          <template slot-scope="scope">
            <div>{{orderAccountStatus[scope.row.orderAccountStatus]}}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="address" label="操作">
          <template slot-scope="scope">
            <div>
              <!-- 0已完成 2待商务接单 3已接单   4已拒单 -->
              <div v-if="scope.row.orderAccountStatus == 2">
                <el-button type="text" @click="pickOrderClick(scope.row.id,scope.row.orderId,3)">接单</el-button>
                <el-button type="text" @click="pickOrderClick(scope.row.id,scope.row.orderId,4)">拒单</el-button>
              </div>
              <div v-if="scope.row.orderAccountStatus == 3">
                <el-button type="text" @click="completeClick(scope.row.id,scope.row.orderId,1)">完成</el-button>
                <el-button type="text" @click="pickOrderClick(scope.row.id,scope.row.orderId,4)">拒单</el-button>
              </div>
              <div v-if="scope.row.orderAccountStatus == 0">
                 <el-button type="text" @click="completeClick(scope.row.id,scope.row.orderId,2,scope.row.completeDetails)">完成详情</el-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="text-align:right;padding-bottom:20px;">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formInline.pageNum"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="formInline.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 完成输入 -->
    <el-dialog
        title="确认完成投放吗?"
        :visible.sync="dialogVisible"
        width="25%">
        <div>
            <span>完成详情：</span>
            <el-input style="margin-top:10px;" rows="4" type="textarea" placeholder="请输入内容" v-model="textarea" maxlength="200" show-word-limit></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="completeValueClick">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>
<script>
import { businessOrder_list, receive_order, update_order_account } from "@/api/order/index";
export default {
  data() {
    return {
      loading:false,
      orderAccountStatus:['已完成','','待商务接单','已接单','已拒单'],
      formInline: {
        accountName:"",//账号名称
        orderName:"",//订单编号名称
        createUserName:"",//下单人
        pageNum: 1,
        pageSize: 10,
        orderStatus: "",
      },
      detailsType:1,
      textarea:"",
      dialogVisible:false,
      total:0,
      ztList: [
        { value: 2, label: "待接单" },
        { value: 3, label: "已接单" },
        { value: 4, label: "已拒单" },
        { value: 0, label: "已完成" },
      ],
      tableData: [],
      orderList:{}
    };
  },
  methods: {
    businessOrder_list(){
      this.loading = true;
      businessOrder_list(this.formInline).then(res=>{
        this.tableData = res.data;
        this.total = res.total
        console.log('====博主商务内部订单查询====',res)
        this.loading = false;
      })
    },
    //完成信息
    completeValueClick(){
      if(!this.textarea){
        this.$message({
            message: '请输入完成详情信息',
            type: 'warning'
        });
      }else{
        update_order_account({
          id:this.orderList.id,
          orderId:this.orderList.orderId,
          completeDetails:this.textarea,
        },2).then(res=>{
          if(res.code === 1){
            this.businessOrder_list()
          }
          this.dialogVisible = false;
          this.textarea = "";
          console.log('=====接口请求====',res)
        })
        // this.dialogVisible = false
      }
    },
    //接单
    pickOrderClick(id,orderId,type){
        this.$confirm(type==3?'确认接单吗?':'确认拒绝接单吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          receive_order({
            accountId:id,
            orderId:orderId,
            type:type
          }).then(res=>{
            if(res.code === 1){
              this.businessOrder_list()
            }
          })
        }).catch(() => {
         
        });
    },
    //完成
    completeClick(id,orderId,type,test){
      if(type == 2){
        this.$alert(test, '完成详情', {
            showConfirmButton:false,
            callback: action => {

            }
        });
      }else{
        this.orderList={
          id:id,
          orderId:orderId
        }
        this.dialogVisible = true;
      }
    },
    //查询
    onSubmit() {
      this.formInline.pageNum=1;
      this.businessOrder_list()
    },
    editClick(){},
    handleSizeChange(val) {
      this.formInline.pageSize=val;
      this.businessOrder_list()
    },
    handleCurrentChange(val) {
      this.formInline.pageNum=val;
      this.businessOrder_list()
    }
  },
  computed: {},
  mounted() {
    this.businessOrder_list()
  },
};
</script>
<style lang="scss" scoped>
.orderList {
  margin-top: 10px;
  padding: 20px;
  background: #fff;
}
.accontBox{
  display: flex;
  align-items: center;
  margin-left:40px;
}
//基础信息
.info-wrap {
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 12px;
  text-align: left;
  .nickname {
    max-width: 65px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.typeImgWx{
  display: inline-block;
  width: 50px;
  height: 30px;
  margin-top: 5px;
  background: url('/img/media-type.png') no-repeat top center/100% auto;
}
.typeImgTb{
  display: inline-block;
  width: 50px;
  height: 30px;
  margin-top: 5px;
  background: url('/img/media-type.png') no-repeat top center/100% auto;
  background-position: 0 -180px;
}
.typeImgDy{
  display: inline-block;
  width: 50px;
  height: 30px;
  margin-top: 5px;
  background: url('/img/media-type.png') no-repeat top center/100% auto;
  background-position: 0 -90px;
}
</style>